import * as types from "../constants/ActionTypes";

const initialState =
{
    user: {
        fullName: "",
        kerbId: "",
        role: ""
    },
    privacySettings: [],
    page: "search"
};

export default function app(state = initialState, action: any) 
{
    switch (action.type) 
    {
        case types.CHANGE_USER:
            {
                return { ...state, user: action.payload };
            }
        case types.CHANGE_PAGE:
            {
                return { ...state, page: action.payload };
            }
        case types.SET_PRIVACY_SETTINGS:
            {
                return { ...state, privacySettings: action.payload };
            }
        case types.CHANGE_PRIVACY_SETTINGS:
            {
                return { ...state, privacySettings: action.payload };
            }
        default:
            return state;
    }
}